import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { SlackIntegration } from './types';

type Variables = void;
type Response = SlackIntegration;

export const useSlackIntegration = createQuery<Response, Variables, AxiosError>(
  {
    queryKey: ['internal/partners/organizations/integrations/slack'],
    fetcher: () =>
      client
        .get('v2/internal/partners/organizations/integrations/slack')
        .then((response) => response.data.data),
  }
);
